export default "__VITE_ASSET__Bt_Rr7QZ__"